export const ADD_VISITOR = "ADD_VISITOR";
export const ADD_VISITOR_SUCCESS = "ADD_VISITOR_SUCCESS";
export const ADD_VISITOR_FAIL = "ADD_VISITOR_FAIL";

export const UPDATE_VISITOR = "UPDATE_VISITOR";
export const UPDATE_VISITOR_SUCCESS = "UPDATE_VISITOR_SUCCESS";
export const UPDATE_VISITOR_FAIL = "UPDATE_VISITOR_FAIL";

export const VISITOR_LIST = "VISITOR_LIST";
export const VISITOR_LIST_SUCCESS = "VISITOR_LIST_SUCCESS";
export const VISITOR_LIST_FAIL = "VISITOR_LIST_FAIL";

export const REMOVE_VISITOR_FILE = "REMOVE_VISITOR_FILE";
export const REMOVE_VISITOR_FILE_SUCCESS = "REMOVE_VISITOR_FILE_SUCCESS";
export const REMOVE_VISITOR_FILE_FAIL = "REMOVE_VISITOR_FILE_FAIL";

export const SERVICE_LIST = "SERVICE_LIST";
export const SERVICE_LIST_SUCCESS = "SERVICE_LIST_SUCCESS";
export const SERVICE_LIST_FAIL = "SERVICE_LIST_FAIL";

export const ADD_SERVICE = "ADD_SERVICE";
export const ADD_SERVICE_SUCCESS = "ADD_SERVICE_SUCCESS";
export const ADD_SERVICE_FAIL = "ADD_SERVICE_FAIL";

export const UPDATE_SERVICE = "UPDATE_SERVICE";
export const UPDATE_SERVICE_SUCCESS = "UPDATE_SERVICE_SUCCESS";
export const UPDATE_SERVICE_FAIL = "UPDATE_SERVICE_FAIL";

export const CONTRACTOR_LIST = "CONTRACTOR_LIST";
export const CONTRACTOR_LIST_SUCCESS = "CONTRACTOR_LIST_SUCCESS";
export const CONTRACTOR_LIST_FAIL = "CONTRACTOR_LIST_FAIL";

export const ADD_CONTRACTOR = "ADD_CONTRACTOR";
export const ADD_CONTRACTOR_SUCCESS = "ADD_CONTRACTOR_SUCCESS";
export const ADD_CONTRACTOR_FAIL = "ADD_CONTRACTOR_FAIL";

export const CONTRACTOR_STATUS = "CONTRACTOR_STATUS";
export const CONTRACTOR_STATUS_SUCCESS = "CONTRACTOR_STATUS_SUCCESS";
export const CONTRACTOR_STATUS_FAIL = "CONTRACTOR_STATUS_FAIL";

export const UPDATE_CONTRACTOR = "UPDATE_CONTRACTOR";
export const UPDATE_CONTRACTOR_SUCCESS = "UPDATE_CONTRACTOR_SUCCESS";
export const UPDATE_CONTRACTOR_FAIL = "UPDATE_CONTRACTOR_FAIL";

export const UPDATE_LOCATION = "UPDATE_LOCATION";
export const UPDATE_LOCATION_SUCCESS = "UPDATE_LOCATION_SUCCESS";
export const UPDATE_LOCATION_FAIL = "UPDATE_LOCATION_FAIL";
